export default [
  {
    Leaders: [
      {
        Name: "Saif Shakeel",
        Post: "Captain",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "/assets/saif.jpg",
      },
      {
        Name: "Mohammad Mudassir Ali",
        Post: "Vice-Captain",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "/assets/mudassir.jpg",
      },
      {
        Name: "Yashra Malik",
        Post: "Team Manager",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "/assets/yashra_photo.jpeg",
      },
      {
        Name: "Batte Arafat Degea",
        Post: "Chasis Lead",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "/assets/batte.jpg",
      },
      {
        Name: "Arhaan Nawab",
        Post: "Power Train Lead",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "/assets/arhaan.jpeg",
      },
      {
        Name: "Mohd. Fahad",
        Post: "Vehicular Electronics Lead",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "/assets/fahad.jpg",
      },
      {
        Name: "Muhammad Haris",
        Post: "Vehicle Dynamics Lead",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "/assets/harris.jpeg",
      },
      {
        Name: "Mustafa Rais",
        Post: "Treasurer",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "/assets/mustafa_rais.jpeg",
      },
    ],
  },
  {
    ChasisMembers: [
      {
        Name: "Mohd Saifullah ",
        Post: "Chasis",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Owais Warsi",
        Post: "Chasis",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Kuldeepak Singh",
        Post: "Chasis",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Nahid Pravez",
        Post: "Chasis",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },

      {
        Name: "Vansh Bharadwaj",
        Post: "Chasis",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },

      {
        Name: "Muddassir Ali",
        Post: "Chasis",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
    ],
  },

  {
    PowerTrain: [
      {
        Name: "Maaz Ahmed",
        Post: "Power Train",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Ruhan Ali Niazi",
        Post: "Power Train",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Mohd Shariq",
        Post: "Power Train",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Ashish Choudhary",
        Post: "Power Train",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Hamid Raza",
        Post: "Power Train",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Mohammad Zaid Qureshi",
        Post: "Power Train",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "MD Yousuf",
        Post: "Power Train",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Adnan HUssain",
        Post: "Power Train",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
    ],
  },

  {
    ElectronicsMembers: [
      {
        Name: "Mohd Yousuf Raza",
        Post: "Vehicle Electronics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Hera Fatma",
        Post: "Vehicle Electronics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Saeem Shamshad",
        Post: "Vehicle Electronics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Mukhtar Khan",
        Post: "Vehicle Electronics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Ankit Raghav",
        Post: "Vehicle Electronics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Priya Sharma",
        Post: "Vehicle Electronics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Ishan Khan",
        Post: "Vehicle Electronics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Zeeshan Khan",
        Post: "Vehicle Electronics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
    ],
  },

  {
    VDynamicsMembers: [
      {
        Name: "Saad Athar",
        Post: "Vehicle Dynamics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Alfaiz Khan",
        Post: "Vehicle Dynamics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Mohd Nazim Umar",
        Post: "Vehicle Dynamics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Junaid Warsi",
        Post: "Vehicle Dynamics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Adnan Zafar",
        Post: "Vehicle Dynamics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Safoora Hafeez",
        Post: "Vehicle Dynamics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Haris Mirza",
        Post: "Vehicle Dynamics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Affan Khan",
        Post: "Vehicle Dynamics",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
    ],
  },

  {
    ManagementMembers: [
      {
        Name: "Chhaya Chaudhary",
        Post: "Web Developer",
        LinkedIn: "https://www.linkedin.com/in/chhaya-chaudhary-963362287",
        Insta: "",
        Email: "chhayachaudhary1212@gmail.com",
      },
      {
        Name: "Khushnuma",
        Post: "Web Developer",
        LinkedIn: "/https:/www.linkedin.com/in/khushnuma-237309295",
        Insta: "",
        Email: "khushnumaa65@gmail.com",
      },
      {
        Name: "Abdul Tavvab",
        Post: "",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
      {
        Name: "Mohammad Hamza Siddique",
        Post: "",
        LinkedIn: "",
        Gmail: "",
        Insta: "",
        Photo: "",
      },
    ],
  },
];
